import { StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';
function CancelXIconRaw({
  fill,
}: {
  style?: StyleProp<ViewStyle>;
  fill?: string;
  className?: string;
}) {
  return (
    <Svg width="15" height="15" viewBox="0 0 15 15" fill={fill}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1457 2.08135L14.676 1.55102L13.6153 0.490356L13.085 1.02069L7.61535 6.49036L2.14568 1.02069L1.61535 0.490356L0.554688 1.55102L1.08502 2.08135L6.55469 7.55102L1.08502 13.0207L0.554688 13.551L1.61535 14.6117L2.14568 14.0813L7.61535 8.61168L13.085 14.0813L13.6153 14.6117L14.676 13.551L14.1457 13.0207L8.67601 7.55102L14.1457 2.08135Z"
        fill="white"
      />
    </Svg>
  );
}

export const CancelXIcon = nativewindWrapSvg(CancelXIconRaw);
